import React, { ReactNode } from "react"
import styled from "styled-components"
import Modal from "react-bootstrap/Modal"
import { Spinner } from "react-bootstrap"
import { Icon } from "~/components/atoms/styled/Icon"
import { nl2br } from "~/utils/functions"

interface Props {
  show: boolean | null
  title?: string | ReactNode
  size?: "xl" | "lg" | "sm" | "md"
  disabled?: boolean
  isLoading?: boolean
  errorMessage?: string
  onHide?: () => void
  children?: JSX.Element | JSX.Element[]
}

export default function AcModal(props: Props) {
  const {
    show,
    title,
    size,
    disabled = false,
    isLoading = false,
    errorMessage = "",
    onHide,
    children = [],
  } = props
  const elements = !Array.isArray(children) ? [children] : children
  const ModalBodyContents = elements.find((element) => element.key === "body")
  const ModalFooterContents = elements.find((element) => element.key === "footer")
  return (
    <>
      <ExModal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={Boolean(show)}
        onHide={() => {
          if (!disabled && !isLoading) {
            onHide?.call(this)
          }
        }}
        size={size}
      >
        <ExModalHeader closeButton={!disabled}>
          <Modal.Title>{title}</Modal.Title>
        </ExModalHeader>
        <ExModalBody>
          {!isLoading && show && errorMessage && (
            <Processing>
              <Exclamation />
              <p>{nl2br(errorMessage)}</p>
            </Processing>
          )}

          {!isLoading && ModalBodyContents}

          {isLoading && (
            <Processing>
              <ProcessingSpinner animation="border" />
              <p>処理中です、しばらくお待ちください。</p>
            </Processing>
          )}
        </ExModalBody>
        {ModalFooterContents && !isLoading && <Modal.Footer>{ModalFooterContents}</Modal.Footer>}
      </ExModal>
    </>
  )
}

const ExModal = styled(Modal)`
  & .modal-content {
    border-radius: 20px !important;

    & .modal-footer {
      justify-content: center;
      border-top: none;
      padding-bottom: 64px;
      & .row {
        justify-content: center;
        flex-wrap: nowrap;
        width: 100%;
      }
      @media screen and (max-width: 860px) {
        .row {
          flex-wrap: wrap;
        }
      }
    }
  }
`

export const ModalInnerTitle = styled.h2`
  font-size: 20px !important;
  text-align: center;
  margin: 40px !important;
  word-break: break-word;
`
const ExModalHeader = styled(Modal.Header)`
  position: relative;
  background-color: #ebeef9;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  height: 90px;
  & .h4 {
    width: 100%;
    text-align: center;
    //font-family: "Noto Sans JP";
    font-weight: bold;
    font-size: 20px;
    color: #555555;
  }
  & .btn-close {
    position: absolute;
    right: 20px;
  }
`

const ExModalBody = styled(Modal.Body)`
  //padding: 0 80px;
  z-index: 999;
  padding: 0;
  //padding-bottom: 24px;
  .icon {
    margin: 30px 0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    & svg {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      padding: 20px;
    }
  }
  .notice {
    text-align: center;
  }
`

const Processing = styled.div`
  min-height: 300px;
  text-align: center;
`

const ProcessingSpinner = styled(Spinner)`
  color: #11bc4c;
  width: 90px;
  height: 90px;
  margin: 50px 0;
`

const Exclamation = styled(Icon.Exclamation)`
  color: #11bc4c;
  width: 90px;
  height: 90px;
  margin-bottom: 50px;
  padding: 2% !important;
`
